import { IonItem, IonAvatar, IonLabel, IonRouterOutlet } from '@ionic/react';
import { url } from 'inspector';
import { ReactElement, JSXElementConstructor, ReactFragment, ReactPortal } from 'react';
import { Route, Redirect } from 'react-router';
import './ListContainer.css';

import ResultPage from '../pages/Results';
import { IonReactRouter } from '@ionic/react-router';

interface ContainerProps { }

function FantasyContainer(id: any, logo: any, name:any){
    var url = '/fantasyLeague/'+id;
  return (
    <IonItem key={id} href={url}>
          <IonAvatar slot="start">
              <img alt="logo" src={logo} />
          </IonAvatar>
          <IonLabel>
              {name}
          </IonLabel>
      </IonItem>
  );
};

export default FantasyContainer;